import React from "react";
import {Navigate} from "react-router-dom";
import useAppContext from "../hooks/useAppHook";
import {canViewTeamPulse} from "../utils/teamPulseAccess";

const TeamPulseRoute = ({children}: {children: React.ReactElement}) => {
    const {user} = useAppContext();

    return canViewTeamPulse(user) ? children : <Navigate to="/home" replace/>;
};

export default TeamPulseRoute;
